import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Auth.css";
import Logo from "../Assets/BooksCompl.png";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState({ content: "", type: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setMessage({ content: "Passwords do not match", type: "danger" });
      return;
    }

    if (password.length < 6) {
      setMessage({ 
        content: "Password must be at least 6 characters", 
        type: "danger" 
      });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/reset-password/${token}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to reset password");
      }

      setMessage({ 
        content: data.message || "Password reset successfully! Redirecting to login...", 
        type: "success" 
      });

      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      setMessage({ 
        content: error.message || "An error occurred during password reset", 
        type: "danger" 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid reset-password-container fade-in">
      <div className="main-logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-lg-6 col-md-8 col-sm-10 reset-password-card p-4">
          <div className="text-center mb-4">
            <h2>Reset Your Password</h2>
            <p className="text-muted">Enter your new password below</p>
          </div>

          {message.content && (  
            <div className={`alert alert-${message.type}`} role="alert">
              {message.content}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3 position-relative">
              <FaLock className="input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="New Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="form-group mb-3 position-relative">
              <FaLock className="input-icon" />
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <span
                className="password-toggle"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Resetting Password...
                </>
              ) : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;